import './Sidebar.scss';
import { Link, withRouter } from 'react-router-dom';
import { Popover } from 'antd';
import { Switch } from 'antd';
import { Tooltip } from '@mui/material';
import { createTrue } from 'typescript';
import { v4 as uuidv4 } from 'uuid';
import { withTranslation } from 'react-i18next';
import API from '../services/API';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AppContext from '../AppContext';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Cookies from 'js-cookie';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, LanguageChanger } from '@photocarbone/nooco-ui';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import React, { Component } from 'react';
import catalogPic from '../../assets/images/catalogue.png';
import simulatorPic from '../../assets/images/sidebar/simulator.png';
import { signOut } from 'aws-amplify/auth';
import biPng from '../../assets/images/sidebar/bi.png';
import manufPng from '../../assets/images/sidebar/manufPng.png';
import ProjectSimulatorSVG from '../../assets/images/projectSimulator/ProjectSimulatorSVG';
import { isUserComeFromVinciSSOWithoutVerifyHisMail } from '../AppRoutes';

let openLogo = require('../../assets/images/noocoLogo.png');
let logo = require('../../assets/images/ocoicon.png');
let bundle = require('../../assets/images/bundle/bundle.svg');

openLogo = typeof openLogo === 'object' ? openLogo.default : openLogo;
logo = typeof logo === 'object' ? logo.default : logo;
bundle = typeof bundle === 'object' ? bundle.default : bundle;

// const featuresIdFromLocalStorage = JSON.parse(localStorage.getItem('featuresConsulted')) || [];

class Sidebar extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);

    this.state = {
      expanded: false,
      typeProject: null,
    };
    this.api = new API(true);
  }

  state = {};

  returnTemplateName = (name, t) => {
    switch (name) {
      case 'Travaux neuf':
        return t('APP.SHARED.SIDEBAR.PH_05920A', {
          defaultValue: 'Travaux neuf',
        });
      case 'Travaux rénovation':
        return t('APP.SHARED.SIDEBAR.PH_4E82E5', {
          defaultValue: 'Travaux rénovation',
        });
      case 'Travaux exploitation':
        return t('APP.SHARED.SIDEBAR.PH_F3C381', {
          defaultValue: 'Travaux exploitation',
        });
      case 'Aéroport':
        return t('APP.SHARED.SIDEBAR.PH_CB1E66', { defaultValue: 'Aéroport' });
      case 'Datacenter':
        return t('APP.SHARED.SIDEBAR.PH_D6B635', {
          defaultValue: 'Datacenter',
        });
      case 'Infrastructure extérieure':
        return t('APP.SHARED.SIDEBAR.PH_763A59', {
          defaultValue: 'Infrastructure extérieure',
        });
      case 'Prototype':
        return t('APP.SHARED.SIDEBAR.PH_F89C6C', { defaultValue: 'Prototype' });
    }
  };

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.props.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.props.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.props.setState({ [i]: false });
      });
      this.props.setState({ [menuState]: true });
    }
  }

  async logout() {
    this.api.logout();
    this.props.userLogout();
    signOut();

    setTimeout(() => {
      this.props.setState({ isLoaded: true });
      this.props.setState({ isLoading: false });

      this.props.setState({ isLoadingProjects: false });
      this.props.setState({ isAdmin: false });
      this.props.setState({ isSuperAdmin: false });

      this.props.setState({ isLoadingGenerateRSEnv: false });
      this.props.setState({ isAuth: false });

      this.props.setState({ user: null });
    }, 1000);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }

    if (
      this.props.allCompanies?.length === 0 &&
      !isUserComeFromVinciSSOWithoutVerifyHisMail(this.props.user)
    ) {
      this.logout();

      return;
    }

    let newFeatureDetected = false;

    for (let feature of this.props.features) {
      if (!this.props.localFeature.includes(feature.id)) {
        newFeatureDetected = true;
        break;
      }
    }

    if (newFeatureDetected) {
      this.props.updateIsNewFeature(true);
    } else if (this.props.localFeature.length === 0) {
      this.props.updateIsNewFeature(true);
    } else {
      if (this.props.isNewFeature2) {
        this.props.updateIsNewFeature(false);
      }

      // this.props.updateIsNewFeature(false);
    }
  }

  componentWillUnmount() {
    this.props.setState({
      typeProject: null,
    });
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach((i) => {
      this.props.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.props.setState({ [obj.state]: true });
      }
    });
  }

  renderRightsGesture(t) {
    if (this.props.isSuperAdmin || this.props.isCompanyAdmin) {
      return (
        <li
          className={
            this.isPathActive('/rights')
              ? this.props.isDarkMode
                ? 'nav-item active dark'
                : 'nav-item active'
              : this.props.isDarkMode
              ? 'nav-item dark'
              : 'nav-item'
          }
        >
          <Link
            className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}
            to="/rights"
          >
            {/* <i className="mdi mdi-account-card-details menu-icon" /> */}
            <div
              className={
                this.isPathActive('/rights') ? 'svgWrapper active' : 'svgWrapper'
              }
            >
              {!this.props.isMenuOpen ? (
                <Tooltip title="Accès">
                  <svg
                    viewBox="0 0 24 24"
                    width="24px"
                    height="24px"
                    fill="current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 3C6.23858 3 4 5.23858 4 8C4 10.7614 6.23858 13 9 13C11.7614 13 14 10.7614 14 8C14 5.23858 11.7614 3 9 3ZM6 8C6 6.34315 7.34315 5 9 5C10.6569 5 12 6.34315 12 8C12 9.65685 10.6569 11 9 11C7.34315 11 6 9.65685 6 8Z" />
                    <path d="M16.9084 8.21828C16.6271 8.07484 16.3158 8.00006 16 8.00006V6.00006C16.6316 6.00006 17.2542 6.14956 17.8169 6.43645C17.8789 6.46805 17.9399 6.50121 18 6.5359C18.4854 6.81614 18.9072 7.19569 19.2373 7.65055C19.6083 8.16172 19.8529 8.75347 19.9512 9.37737C20.0496 10.0013 19.9987 10.6396 19.8029 11.2401C19.6071 11.8405 19.2719 12.3861 18.8247 12.8321C18.3775 13.2782 17.8311 13.6119 17.2301 13.8062C16.6953 13.979 16.1308 14.037 15.5735 13.9772C15.5046 13.9698 15.4357 13.9606 15.367 13.9496C14.7438 13.8497 14.1531 13.6038 13.6431 13.2319L13.6421 13.2311L14.821 11.6156C15.0761 11.8017 15.3717 11.9248 15.6835 11.9747C15.9953 12.0247 16.3145 12.0001 16.615 11.903C16.9155 11.8059 17.1887 11.639 17.4123 11.416C17.6359 11.193 17.8035 10.9202 17.9014 10.62C17.9993 10.3198 18.0247 10.0006 17.9756 9.68869C17.9264 9.37675 17.8041 9.08089 17.6186 8.82531C17.4331 8.56974 17.1898 8.36172 16.9084 8.21828Z" />
                    <path d="M19.9981 21C19.9981 20.475 19.8947 19.9551 19.6938 19.47C19.4928 18.9849 19.1983 18.5442 18.8271 18.1729C18.4558 17.8017 18.0151 17.5072 17.53 17.3062C17.0449 17.1053 16.525 17.0019 16 17.0019V15C16.6821 15 17.3584 15.1163 18 15.3431C18.0996 15.3783 18.1983 15.4162 18.2961 15.4567C19.0241 15.7583 19.6855 16.2002 20.2426 16.7574C20.7998 17.3145 21.2417 17.9759 21.5433 18.7039C21.5838 18.8017 21.6217 18.9004 21.6569 19C21.8837 19.6416 22 20.3179 22 21H19.9981Z" />
                    <path d="M16 21H14C14 18.2386 11.7614 16 9 16C6.23858 16 4 18.2386 4 21H2C2 17.134 5.13401 14 9 14C12.866 14 16 17.134 16 21Z" />
                  </svg>
                </Tooltip>
              ) : (
                <svg
                  viewBox="0 0 24 24"
                  width="24px"
                  height="24px"
                  fill="current"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9 3C6.23858 3 4 5.23858 4 8C4 10.7614 6.23858 13 9 13C11.7614 13 14 10.7614 14 8C14 5.23858 11.7614 3 9 3ZM6 8C6 6.34315 7.34315 5 9 5C10.6569 5 12 6.34315 12 8C12 9.65685 10.6569 11 9 11C7.34315 11 6 9.65685 6 8Z" />
                  <path d="M16.9084 8.21828C16.6271 8.07484 16.3158 8.00006 16 8.00006V6.00006C16.6316 6.00006 17.2542 6.14956 17.8169 6.43645C17.8789 6.46805 17.9399 6.50121 18 6.5359C18.4854 6.81614 18.9072 7.19569 19.2373 7.65055C19.6083 8.16172 19.8529 8.75347 19.9512 9.37737C20.0496 10.0013 19.9987 10.6396 19.8029 11.2401C19.6071 11.8405 19.2719 12.3861 18.8247 12.8321C18.3775 13.2782 17.8311 13.6119 17.2301 13.8062C16.6953 13.979 16.1308 14.037 15.5735 13.9772C15.5046 13.9698 15.4357 13.9606 15.367 13.9496C14.7438 13.8497 14.1531 13.6038 13.6431 13.2319L13.6421 13.2311L14.821 11.6156C15.0761 11.8017 15.3717 11.9248 15.6835 11.9747C15.9953 12.0247 16.3145 12.0001 16.615 11.903C16.9155 11.8059 17.1887 11.639 17.4123 11.416C17.6359 11.193 17.8035 10.9202 17.9014 10.62C17.9993 10.3198 18.0247 10.0006 17.9756 9.68869C17.9264 9.37675 17.8041 9.08089 17.6186 8.82531C17.4331 8.56974 17.1898 8.36172 16.9084 8.21828Z" />
                  <path d="M19.9981 21C19.9981 20.475 19.8947 19.9551 19.6938 19.47C19.4928 18.9849 19.1983 18.5442 18.8271 18.1729C18.4558 17.8017 18.0151 17.5072 17.53 17.3062C17.0449 17.1053 16.525 17.0019 16 17.0019V15C16.6821 15 17.3584 15.1163 18 15.3431C18.0996 15.3783 18.1983 15.4162 18.2961 15.4567C19.0241 15.7583 19.6855 16.2002 20.2426 16.7574C20.7998 17.3145 21.2417 17.9759 21.5433 18.7039C21.5838 18.8017 21.6217 18.9004 21.6569 19C21.8837 19.6416 22 20.3179 22 21H19.9981Z" />
                  <path d="M16 21H14C14 18.2386 11.7614 16 9 16C6.23858 16 4 18.2386 4 21H2C2 17.134 5.13401 14 9 14C12.866 14 16 17.134 16 21Z" />
                </svg>
              )}
            </div>
            {this.props.isMenuOpen && (
              <div className="menu-title">
                {t('APP.SHARED.SIDEBAR.PH_31AF1C', { defaultValue: 'Accès' })}
              </div>
            )}
          </Link>
        </li>
      );
    }
  }

  renderBundleLink(t) {
    return (
      <li
        className={
          this.isPathActive('/library')
            ? this.props.isDarkMode
              ? 'nav-item active dark'
              : 'nav-item active'
            : this.props.isDarkMode
            ? 'nav-item dark'
            : 'nav-item'
        }
        style={{
          backgroundColor: this.props.licenceTypeAccess === 'read' ? '#E9EDF6' : '',
          cursor: this.props.licenceTypeAccess === 'read' ? 'not-allowed' : '',
        }}
      >
        {this.props.licenceTypeAccess !== 'read' && (
          <Link
            className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}
            to={'/library'}
          >
            <div
              className={
                this.isPathActive('/library') ? 'svgWrapper active' : 'svgWrapper'
              }
            >
              {!this.props.isMenuOpen ? (
                <Tooltip
                  title={t('APP.SHARED.SIDEBAR.PH_B72516', {
                    defaultValue: 'Ma bibiliothèque',
                  })}
                >
                  <img
                    style={{
                      filter: this.isPathActive('/library')
                        ? 'invert(0%) sepia(100%) saturate(5%) hue-rotate(1deg) brightness(107%) contrast(100%)'
                        : null,
                    }}
                    src={bundle}
                    alt="logo-bundle"
                  />
                </Tooltip>
              ) : (
                <img
                  style={{
                    filter: this.isPathActive('/library')
                      ? 'invert(0%) sepia(100%) saturate(5%) hue-rotate(1deg) brightness(107%) contrast(100%)'
                      : null,
                  }}
                  src={bundle}
                  alt="logo-bundle"
                />
              )}
            </div>
            {this.props.isMenuOpen && (
              <div className="menu-title">
                {t('APP.SHARED.SIDEBAR.PH_E5A73C', {
                  defaultValue: 'Ma bibiliothèque',
                })}
              </div>
            )}
          </Link>
        )}

        {this.props.licenceTypeAccess === 'read' && (
          <Tooltip
            title={t('APP.SHARED.SIDEBAR.PH_D95924', {
              defaultValue:
                'Fonctionnalité disponible avec une licence light ou pro seulement',
            })}
            placement="right"
          >
            <div className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}>
              <div
                className={
                  this.isPathActive('/library') ? 'svgWrapper active' : 'svgWrapper'
                }
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="current"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_116_959)">
                    <path d="M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13V17.13Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_116_959">
                      <rect width="24" height="24" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {this.props.isMenuOpen && (
                <div
                  style={{
                    cursor: 'not-allowed',
                  }}
                  className="menu-title"
                >
                  Ma bibliothèque
                </div>
              )}
            </div>
          </Tooltip>
        )}
      </li>
    );
  }

  render() {
    const { t, i18n } = this.props;
    const isEnglishLanguage = i18n.language === 'en-GB';
    const renderTypeProjectMenuPopOver = () => {
      return (
        <div
          className={
            this.props.isDarkMode ? 'wrapper-small-menuDark' : 'wrapper-small-menu'
          }
        >
          <div className="type-project-template">
            {this.props.templateTypeAvailable.map((templateType) => (
              <div
                // key={templateType.id}
                key={uuidv4()}
                className={
                  this.props.isDarkMode
                    ? 'type-project-select dark'
                    : 'type-project-select'
                }
              >
                <div className="vector"></div>
                <div className="vector-left"></div>
                <p
                  className={`type-project ${
                    this.state.typeProject === templateType.name
                      ? 'active-typeProject'
                      : null
                  } ${this.props.isDarkMode ? 'dark' : null}`}
                  onClick={() => filterOnTemplateType(templateType)}
                >
                  {this.returnTemplateName(templateType.name, t)}
                </p>
              </div>
            ))}
            {/* <p className="type-project">Travaux exploitation</p>
                      <p className="type-project">Aéroport</p>
                      <p className="type-project">Datacenter</p>
                      <p className="type-project">Infrastructure extérieure</p> */}
          </div>
        </div>
      );
    };

    if (!this.context.isAuthenticated) return null;

    const user = this.context.user.attributes;
    const name = user?.given_name + ' ' + user?.family_name.charAt(0) + '.';

    const filterOnTemplateType = (templateType) => {
      if (this.props.location.pathname !== '/projects') {
        this.props.history.push('/projects');
      }

      this.props.updateProjectsListMonitoring(
        'projectTypeFilter',
        templateType ? templateType.queryParams : []
      );
      this.props.updateFormValue(
        'searchTypeProject',
        templateType ? templateType.queryParams : null
      );
      //       this.props.fetchProjects(true,
      //         null,
      // templateType?.queryParams);
      this.props.setState({
        ...this.state,
        typeProject: templateType ? templateType.name : null,
      });
    };

    const randomValue = Math.random().toString(36).substring(7);

    return (
      <nav
        className={
          this.props.isMenuOpen
            ? this.props.isDarkMode
              ? 'sidebar sidebar-offcanvas test dark'
              : 'sidebar sidebar-offcanvas test'
            : this.props.isDarkMode
            ? 'sidebar sidebar-offcanvas animation dark'
            : 'sidebar sidebar-offcanvas animation'
        }
        id="sidebar"
      >
        <ul
          className={this.props.isMenuOpen ? 'nav' : 'nav small-navbar'}
          style={
            this.props.isMenuOpen
              ? { width: '220px', minWidth: '220px!important' }
              : { width: '70px !important' }
          }
        >
          <div className="nav-upper">
            <div className="nav-header">
              <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <img
                  style={
                    this.props.isMenuOpen
                      ? { width: '70%', transition: '400ms' }
                      : { width: '50%', marginTop: '20px', transition: '400ms' }
                  }
                  src={
                    this.props.isMenuOpen
                      ? `${openLogo}?v=${randomValue}`
                      : `${logo}?v=${randomValue}`
                  }
                  alt="logo"
                />
              </div>
              <div className="profileNameWrapper">
                <p
                  className={
                    this.props.isDarkMode ? 'profile-name dark' : 'profile-name'
                  }
                >
                  {name}
                </p>
              </div>
            </div>
            <div className={this.props.isMenuOpen ? 'nav-menu small' : 'nav-menu'}>
              <li className="sidebar_languageChanger">
                <LanguageChanger
                  {...{
                    t,
                    i18n,
                    env: process.env.REACT_APP_ENV,
                    isMenuOpen: this.props.isMenuOpen,
                  }}
                />
              </li>
              {this.props.templateTypeAvailable.length === 1 ? (
                <li
                  className={
                    this.isPathActive('/projects')
                      ? this.props.isDarkMode
                        ? 'nav-item active dark'
                        : 'nav-item active'
                      : this.props.isDarkMode
                      ? 'nav-item dark'
                      : 'nav-item'
                  }
                >
                  <Link className="menu-title" to="/projects">
                    <div
                      className={
                        this.isPathActive('/projects')
                          ? 'svgWrapper active'
                          : 'svgWrapper'
                      }
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="current"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_116_915)">
                          <path d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z" />
                        </g>
                        <defs>
                          <clipPath id="clip0_116_915">
                            <rect width="24" height="24" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {this.props.isMenuOpen && (
                      <div className="menu-title">
                        {t('APP.SHARED.SIDEBAR.PH_82A23F', {
                          defaultValue: 'Projets',
                        })}
                      </div>
                    )}
                  </Link>
                </li>
              ) : this.props.isMenuOpen ? (
                <Accordion className="accordion-wrapper">
                  <li
                    className={
                      this.isPathActive('/projects')
                        ? this.props.isDarkMode
                          ? 'nav-item active dark'
                          : 'nav-item active'
                        : this.props.isDarkMode
                        ? 'nav-item dark'
                        : 'nav-item'
                    }
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={`${
                        this.isPathActive('/projects')
                          ? this.props.isDarkMode
                            ? 'nav-item active dark'
                            : 'nav-item active'
                          : this.props.isDarkMode
                          ? 'nav-item dark'
                          : 'nav-item'
                      } ${
                        this.props.isDarkMode
                          ? 'accordion-subwrapper dark'
                          : 'accordion-subwrapper'
                      }`}
                      onClick={() => {
                        !Boolean(
                          this.props.isUserStartEditColumns &&
                            this.props.tableEditMode
                        )
                          ? filterOnTemplateType(null)
                          : null;

                        if (!this.isPathActive('/projects')) {
                          this.props.history.push('/projects');
                        }
                      }}
                    >
                      {/* <i className="mdi mdi-view-grid menu-icon" /> */}
                      {/* <div > */}
                      <div
                        className={
                          this.props.isDarkMode ? 'nav-link dark' : 'nav-link'
                        }
                        to="/projects"
                      >
                        <div
                          className={
                            this.isPathActive('/projects')
                              ? 'svgWrapper active'
                              : 'svgWrapper'
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="current"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_116_915)">
                              <path d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z" />
                            </g>
                            <defs>
                              <clipPath id="clip0_116_915">
                                <rect width="24" height="24" />
                              </clipPath>
                            </defs>
                          </svg>

                          {/* </div> */}
                        </div>
                        <div className="menu-title">
                          {t('APP.SHARED.SIDEBAR.PH_4D5FBB', {
                            defaultValue: 'Projets',
                          })}
                        </div>
                      </div>
                    </AccordionSummary>
                  </li>

                  <AccordionDetails className="accordion-content">
                    <div className="type-project-template">
                      {this.props.templateTypeAvailable.map((templateType) => (
                        <div
                          key={uuidv4()}
                          className={
                            this.props.isDarkMode
                              ? 'type-project-select dark'
                              : 'type-project-select'
                          }
                        >
                          <div className="vector"></div>
                          <div className="vector-left"></div>
                          <p
                            onClick={() =>
                              !Boolean(
                                this.props.isUserStartEditColumns &&
                                  this.props.tableEditMode
                              )
                                ? filterOnTemplateType(null)
                                : null
                            }
                            className={`type-project ${
                              this.state.typeProject ===
                              this.returnTemplateName(templateType.name, t)
                                ? 'active-typeProject'
                                : null
                            }`}
                          >
                            {this.returnTemplateName(templateType.name, t)}
                          </p>
                        </div>
                      ))}
                      {/* <p className="type-project">Travaux exploitation</p>
                      <p className="type-project">Aéroport</p>
                      <p className="type-project">Datacenter</p>
                      <p className="type-project">Infrastructure extérieure</p> */}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Popover
                  content={() => renderTypeProjectMenuPopOver()}
                  placement="right"
                  trigger={'hover'}
                  className={
                    this.props.isDarkMode ? 'wrapperPopoverDark' : 'wrapperPopover'
                  }
                  style={{ backgroundColor: 'red' }}
                >
                  <li
                    onClick={() =>
                      !Boolean(
                        this.props.isUserStartEditColumns && this.props.tableEditMode
                      )
                        ? filterOnTemplateType(null)
                        : null
                    }
                    className={
                      this.isPathActive('/projects')
                        ? this.props.isDarkMode
                          ? 'nav-item active dark'
                          : 'nav-item active'
                        : this.props.isDarkMode
                        ? 'nav-item dark'
                        : 'nav-item'
                    }
                  >
                    <Link
                      className={
                        this.props.isDarkMode ? 'nav-link dark' : 'nav-link'
                      }
                      to="/projects"
                    >
                      {/* <i className="mdi mdi-view-grid menu-icon" /> */}
                      <div
                        className={
                          this.isPathActive('/projects')
                            ? 'svgWrapper active'
                            : 'svgWrapper'
                        }
                      >
                        {!this.props.isMenuOpen ? (
                          <Tooltip
                            placement="right"
                            title={t('APP.SHARED.SIDEBAR.PH_EC5B43', {
                              defaultValue: 'Projets',
                            })}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="current"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_116_915)">
                                <path d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z" />
                              </g>
                              <defs>
                                <clipPath id="clip0_116_915">
                                  <rect width="24" height="24" />
                                </clipPath>
                              </defs>
                            </svg>
                          </Tooltip>
                        ) : (
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="current"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_116_915)">
                              <path d="M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z" />
                            </g>
                            <defs>
                              <clipPath id="clip0_116_915">
                                <rect width="24" height="24" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </div>
                      {this.props.isMenuOpen && (
                        <div className="menu-title">
                          {t('APP.SHARED.SIDEBAR.PH_990AC2', {
                            defaultValue: 'Projets',
                          })}
                        </div>
                      )}
                    </Link>
                  </li>
                </Popover>
              )}
              {this.renderRightsGesture(t)}
              {this.renderBundleLink(t)}
                <li
                  className={
                    this.isPathActive('/project-simulator')
                      ? this.props.isDarkMode
                        ? 'nav-item active dark'
                        : 'nav-item active'
                      : this.props.isDarkMode
                      ? 'nav-item dark'
                      : 'nav-item'
                  }
                  style={{
                    backgroundColor:
                      this.props.licenceTypeAccess === 'read' ? '#E9EDF6' : '',
                    cursor:
                      this.props.licenceTypeAccess === 'read' ? 'not-allowed' : '',
                  }}
                >
                  <Link
                    className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}
                    to="/project-simulator"
                  >
                    <div
                      className={
                        this.isPathActive('/project-simulator')
                          ? 'svgWrapper active'
                          : 'svgWrapper'
                      }
                    >
                      {!this.props.isMenuOpen ? (
                        <ProjectSimulatorSVG
                          isPathActive={this.isPathActive('/project-simulator')}
                        />
                      ) : (
                        <ProjectSimulatorSVG
                          isPathActive={this.isPathActive('/project-simulator')}
                          showTooltip={false}
                        />
                      )}
                    </div>
                    {this.props.isMenuOpen && (
                      <div className="menu-title">
                        {t('APP.SHARED.SIDEBAR.PROJECT.SIMULATOR', {
                          defaultValue: 'Simulateur projet',
                        })}
                      </div>
                    )}
                  </Link>
                </li>
              <li
                className={
                  this.isPathActive('/simulator')
                    ? this.props.isDarkMode
                      ? 'nav-item active dark'
                      : 'nav-item active'
                    : this.props.isDarkMode
                    ? 'nav-item dark'
                    : 'nav-item'
                }
                style={{
                  backgroundColor:
                    this.props.licenceTypeAccess === 'read' ? '#E9EDF6' : '',
                  cursor:
                    this.props.licenceTypeAccess === 'read' ? 'not-allowed' : '',
                }}
              >
                {this.props.licenceTypeAccess !== 'read' && (
                  <Link
                    className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}
                    to="/simulator"
                  >
                    <div
                      className={
                        this.isPathActive('/simulator')
                          ? 'svgWrapper active'
                          : 'svgWrapper'
                      }
                    >
                      {!this.props.isMenuOpen ? (
                        <Tooltip
                          title={t('APP.SHARED.SIDEBAR.PH_DC3E04', {
                            defaultValue: 'Simulateur rapide',
                          })}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="current"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M7.19998 4.80002C6.88172 4.80002 6.57649 4.92645 6.35145 5.1515C6.1264 5.37654 5.99998 5.68176 5.99998 6.00002V8.40002C5.99998 8.71828 6.1264 9.02351 6.35145 9.24855C6.57649 9.4736 6.88172 9.60002 7.19998 9.60002H14.4C14.7182 9.60002 15.0235 9.4736 15.2485 9.24855C15.4735 9.02351 15.6 8.71828 15.6 8.40002V6.00002C15.6 5.68176 15.4735 5.37654 15.2485 5.1515C15.0235 4.92645 14.7182 4.80002 14.4 4.80002H7.19998ZM7.19998 6.00002H14.4V8.40002H7.19998V6.00002ZM9.59998 12C9.59998 11.6818 9.7264 11.3765 9.95145 11.1515C10.1765 10.9265 10.4817 10.8 10.8 10.8C11.1182 10.8 11.4235 10.9265 11.6485 11.1515C11.8735 11.3765 12 11.6818 12 12C12 12.3183 11.8735 12.6235 11.6485 12.8486C11.4235 13.0736 11.1182 13.2 10.8 13.2C10.4817 13.2 10.1765 13.0736 9.95145 12.8486C9.7264 12.6235 9.59998 12.3183 9.59998 12ZM10.8 14.1C10.4817 14.1 10.1765 14.2265 9.95145 14.4515C9.7264 14.6765 9.59998 14.9818 9.59998 15.3C9.59998 15.6183 9.7264 15.9235 9.95145 16.1486C10.1765 16.3736 10.4817 16.5 10.8 16.5C11.1182 16.5 11.4235 16.3736 11.6485 16.1486C11.8735 15.9235 12 15.6183 12 15.3C12 14.9818 11.8735 14.6765 11.6485 14.4515C11.4235 14.2265 11.1182 14.1 10.8 14.1ZM13.2 12C13.2 11.6818 13.3264 11.3765 13.5514 11.1515C13.7765 10.9265 14.0817 10.8 14.4 10.8C14.7182 10.8 15.0235 10.9265 15.2485 11.1515C15.4735 11.3765 15.6 11.6818 15.6 12C15.6 12.3183 15.4735 12.6235 15.2485 12.8486C15.0235 13.0736 14.7182 13.2 14.4 13.2C14.0817 13.2 13.7765 13.0736 13.5514 12.8486C13.3264 12.6235 13.2 12.3183 13.2 12ZM14.4 14.1C14.0817 14.1 13.7765 14.2265 13.5514 14.4515C13.3264 14.6765 13.2 14.9818 13.2 15.3C13.2 15.6183 13.3264 15.9235 13.5514 16.1486C13.7765 16.3736 14.0817 16.5 14.4 16.5C14.7182 16.5 15.0235 16.3736 15.2485 16.1486C15.4735 15.9235 15.6 15.6183 15.6 15.3C15.6 14.9818 15.4735 14.6765 15.2485 14.4515C15.0235 14.2265 14.7182 14.1 14.4 14.1ZM5.99998 12C5.99998 11.6818 6.1264 11.3765 6.35145 11.1515C6.57649 10.9265 6.88172 10.8 7.19998 10.8C7.51824 10.8 7.82346 10.9265 8.0485 11.1515C8.27355 11.3765 8.39998 11.6818 8.39998 12C8.39998 12.3183 8.27355 12.6235 8.0485 12.8486C7.82346 13.0736 7.51824 13.2 7.19998 13.2C6.88172 13.2 6.57649 13.0736 6.35145 12.8486C6.1264 12.6235 5.99998 12.3183 5.99998 12ZM7.19998 14.1C6.88172 14.1 6.57649 14.2265 6.35145 14.4515C6.1264 14.6765 5.99998 14.9818 5.99998 15.3C5.99998 15.6183 6.1264 15.9235 6.35145 16.1486C6.57649 16.3736 6.88172 16.5 7.19998 16.5C7.51824 16.5 7.82346 16.3736 8.0485 16.1486C8.27355 15.9235 8.39998 15.6183 8.39998 15.3C8.39998 14.9818 8.27355 14.6765 8.0485 14.4515C7.82346 14.2265 7.51824 14.1 7.19998 14.1ZM6.59998 2.40002C5.80433 2.40002 5.04126 2.71609 4.47866 3.2787C3.91605 3.84131 3.59998 4.60438 3.59998 5.40002V16.2C3.59998 16.9957 3.91605 17.7587 4.47866 18.3213C5.04126 18.884 5.80433 19.2 6.59998 19.2H15C15.7956 19.2 16.5587 18.884 17.1213 18.3213C17.6839 17.7587 18 16.9957 18 16.2V5.40002C18 4.60438 17.6839 3.84131 17.1213 3.2787C16.5587 2.71609 15.7956 2.40002 15 2.40002H6.59998ZM4.79998 5.40002C4.79998 4.92263 4.98962 4.4648 5.32718 4.12723C5.66475 3.78967 6.12259 3.60002 6.59998 3.60002H15C15.4774 3.60002 15.9352 3.78967 16.2728 4.12723C16.6103 4.4648 16.8 4.92263 16.8 5.40002V16.2C16.8 16.6774 16.6103 17.1353 16.2728 17.4728C15.9352 17.8104 15.4774 18 15 18H6.59998C6.12259 18 5.66475 17.8104 5.32718 17.4728C4.98962 17.1353 4.79998 16.6774 4.79998 16.2V5.40002ZM8.99998 21.6C8.53417 21.6004 8.07471 21.4921 7.65808 21.2838C7.24146 21.0755 6.87916 20.7729 6.59998 20.4H15C16.1139 20.4 17.1822 19.9575 17.9698 19.1699C18.7575 18.3822 19.2 17.3139 19.2 16.2V5.40002C19.9284 5.94722 20.4 6.81842 20.4 7.80002V16.2C20.4 17.6322 19.831 19.0057 18.8184 20.0184C17.8057 21.0311 16.4321 21.6 15 21.6H8.99998Z" />
                          </svg>
                        </Tooltip>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="current"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M7.19998 4.80002C6.88172 4.80002 6.57649 4.92645 6.35145 5.1515C6.1264 5.37654 5.99998 5.68176 5.99998 6.00002V8.40002C5.99998 8.71828 6.1264 9.02351 6.35145 9.24855C6.57649 9.4736 6.88172 9.60002 7.19998 9.60002H14.4C14.7182 9.60002 15.0235 9.4736 15.2485 9.24855C15.4735 9.02351 15.6 8.71828 15.6 8.40002V6.00002C15.6 5.68176 15.4735 5.37654 15.2485 5.1515C15.0235 4.92645 14.7182 4.80002 14.4 4.80002H7.19998ZM7.19998 6.00002H14.4V8.40002H7.19998V6.00002ZM9.59998 12C9.59998 11.6818 9.7264 11.3765 9.95145 11.1515C10.1765 10.9265 10.4817 10.8 10.8 10.8C11.1182 10.8 11.4235 10.9265 11.6485 11.1515C11.8735 11.3765 12 11.6818 12 12C12 12.3183 11.8735 12.6235 11.6485 12.8486C11.4235 13.0736 11.1182 13.2 10.8 13.2C10.4817 13.2 10.1765 13.0736 9.95145 12.8486C9.7264 12.6235 9.59998 12.3183 9.59998 12ZM10.8 14.1C10.4817 14.1 10.1765 14.2265 9.95145 14.4515C9.7264 14.6765 9.59998 14.9818 9.59998 15.3C9.59998 15.6183 9.7264 15.9235 9.95145 16.1486C10.1765 16.3736 10.4817 16.5 10.8 16.5C11.1182 16.5 11.4235 16.3736 11.6485 16.1486C11.8735 15.9235 12 15.6183 12 15.3C12 14.9818 11.8735 14.6765 11.6485 14.4515C11.4235 14.2265 11.1182 14.1 10.8 14.1ZM13.2 12C13.2 11.6818 13.3264 11.3765 13.5514 11.1515C13.7765 10.9265 14.0817 10.8 14.4 10.8C14.7182 10.8 15.0235 10.9265 15.2485 11.1515C15.4735 11.3765 15.6 11.6818 15.6 12C15.6 12.3183 15.4735 12.6235 15.2485 12.8486C15.0235 13.0736 14.7182 13.2 14.4 13.2C14.0817 13.2 13.7765 13.0736 13.5514 12.8486C13.3264 12.6235 13.2 12.3183 13.2 12ZM14.4 14.1C14.0817 14.1 13.7765 14.2265 13.5514 14.4515C13.3264 14.6765 13.2 14.9818 13.2 15.3C13.2 15.6183 13.3264 15.9235 13.5514 16.1486C13.7765 16.3736 14.0817 16.5 14.4 16.5C14.7182 16.5 15.0235 16.3736 15.2485 16.1486C15.4735 15.9235 15.6 15.6183 15.6 15.3C15.6 14.9818 15.4735 14.6765 15.2485 14.4515C15.0235 14.2265 14.7182 14.1 14.4 14.1ZM5.99998 12C5.99998 11.6818 6.1264 11.3765 6.35145 11.1515C6.57649 10.9265 6.88172 10.8 7.19998 10.8C7.51824 10.8 7.82346 10.9265 8.0485 11.1515C8.27355 11.3765 8.39998 11.6818 8.39998 12C8.39998 12.3183 8.27355 12.6235 8.0485 12.8486C7.82346 13.0736 7.51824 13.2 7.19998 13.2C6.88172 13.2 6.57649 13.0736 6.35145 12.8486C6.1264 12.6235 5.99998 12.3183 5.99998 12ZM7.19998 14.1C6.88172 14.1 6.57649 14.2265 6.35145 14.4515C6.1264 14.6765 5.99998 14.9818 5.99998 15.3C5.99998 15.6183 6.1264 15.9235 6.35145 16.1486C6.57649 16.3736 6.88172 16.5 7.19998 16.5C7.51824 16.5 7.82346 16.3736 8.0485 16.1486C8.27355 15.9235 8.39998 15.6183 8.39998 15.3C8.39998 14.9818 8.27355 14.6765 8.0485 14.4515C7.82346 14.2265 7.51824 14.1 7.19998 14.1ZM6.59998 2.40002C5.80433 2.40002 5.04126 2.71609 4.47866 3.2787C3.91605 3.84131 3.59998 4.60438 3.59998 5.40002V16.2C3.59998 16.9957 3.91605 17.7587 4.47866 18.3213C5.04126 18.884 5.80433 19.2 6.59998 19.2H15C15.7956 19.2 16.5587 18.884 17.1213 18.3213C17.6839 17.7587 18 16.9957 18 16.2V5.40002C18 4.60438 17.6839 3.84131 17.1213 3.2787C16.5587 2.71609 15.7956 2.40002 15 2.40002H6.59998ZM4.79998 5.40002C4.79998 4.92263 4.98962 4.4648 5.32718 4.12723C5.66475 3.78967 6.12259 3.60002 6.59998 3.60002H15C15.4774 3.60002 15.9352 3.78967 16.2728 4.12723C16.6103 4.4648 16.8 4.92263 16.8 5.40002V16.2C16.8 16.6774 16.6103 17.1353 16.2728 17.4728C15.9352 17.8104 15.4774 18 15 18H6.59998C6.12259 18 5.66475 17.8104 5.32718 17.4728C4.98962 17.1353 4.79998 16.6774 4.79998 16.2V5.40002ZM8.99998 21.6C8.53417 21.6004 8.07471 21.4921 7.65808 21.2838C7.24146 21.0755 6.87916 20.7729 6.59998 20.4H15C16.1139 20.4 17.1822 19.9575 17.9698 19.1699C18.7575 18.3822 19.2 17.3139 19.2 16.2V5.40002C19.9284 5.94722 20.4 6.81842 20.4 7.80002V16.2C20.4 17.6322 19.831 19.0057 18.8184 20.0184C17.8057 21.0311 16.4321 21.6 15 21.6H8.99998Z" />
                        </svg>
                      )}
                    </div>
                    {this.props.isMenuOpen && (
                      <div className="menu-title">
                        {t('APP.SHARED.SIDEBAR.PH_6511C3', {
                          defaultValue: 'Simulateur rapide',
                        })}
                      </div>
                    )}
                  </Link>
                )}

                {this.props.licenceTypeAccess === 'read' && (
                  <Tooltip
                    title={t('APP.SHARED.SIDEBAR.PH_968D2A', {
                      defaultValue:
                        'Fonctionnalité disponible avec une licence light ou pro seulement',
                    })}
                    placement="right"
                  >
                    <div
                      className={
                        this.props.isDarkMode ? 'nav-link dark' : 'nav-link'
                      }
                      to="/simulator"
                    >
                      {/* <img src={simulatorPic} alt="" style={{ filter: ' brightness(0) invert(1)', width: '20px', marginRight: "1rem"}} className="non-active menu-icon simulatorIcon" /> */}
                      <div
                        className={
                          this.isPathActive('/simulator')
                            ? 'svgWrapper active'
                            : 'svgWrapper'
                        }
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="current"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M7.19998 4.80002C6.88172 4.80002 6.57649 4.92645 6.35145 5.1515C6.1264 5.37654 5.99998 5.68176 5.99998 6.00002V8.40002C5.99998 8.71828 6.1264 9.02351 6.35145 9.24855C6.57649 9.4736 6.88172 9.60002 7.19998 9.60002H14.4C14.7182 9.60002 15.0235 9.4736 15.2485 9.24855C15.4735 9.02351 15.6 8.71828 15.6 8.40002V6.00002C15.6 5.68176 15.4735 5.37654 15.2485 5.1515C15.0235 4.92645 14.7182 4.80002 14.4 4.80002H7.19998ZM7.19998 6.00002H14.4V8.40002H7.19998V6.00002ZM9.59998 12C9.59998 11.6818 9.7264 11.3765 9.95145 11.1515C10.1765 10.9265 10.4817 10.8 10.8 10.8C11.1182 10.8 11.4235 10.9265 11.6485 11.1515C11.8735 11.3765 12 11.6818 12 12C12 12.3183 11.8735 12.6235 11.6485 12.8486C11.4235 13.0736 11.1182 13.2 10.8 13.2C10.4817 13.2 10.1765 13.0736 9.95145 12.8486C9.7264 12.6235 9.59998 12.3183 9.59998 12ZM10.8 14.1C10.4817 14.1 10.1765 14.2265 9.95145 14.4515C9.7264 14.6765 9.59998 14.9818 9.59998 15.3C9.59998 15.6183 9.7264 15.9235 9.95145 16.1486C10.1765 16.3736 10.4817 16.5 10.8 16.5C11.1182 16.5 11.4235 16.3736 11.6485 16.1486C11.8735 15.9235 12 15.6183 12 15.3C12 14.9818 11.8735 14.6765 11.6485 14.4515C11.4235 14.2265 11.1182 14.1 10.8 14.1ZM13.2 12C13.2 11.6818 13.3264 11.3765 13.5514 11.1515C13.7765 10.9265 14.0817 10.8 14.4 10.8C14.7182 10.8 15.0235 10.9265 15.2485 11.1515C15.4735 11.3765 15.6 11.6818 15.6 12C15.6 12.3183 15.4735 12.6235 15.2485 12.8486C15.0235 13.0736 14.7182 13.2 14.4 13.2C14.0817 13.2 13.7765 13.0736 13.5514 12.8486C13.3264 12.6235 13.2 12.3183 13.2 12ZM14.4 14.1C14.0817 14.1 13.7765 14.2265 13.5514 14.4515C13.3264 14.6765 13.2 14.9818 13.2 15.3C13.2 15.6183 13.3264 15.9235 13.5514 16.1486C13.7765 16.3736 14.0817 16.5 14.4 16.5C14.7182 16.5 15.0235 16.3736 15.2485 16.1486C15.4735 15.9235 15.6 15.6183 15.6 15.3C15.6 14.9818 15.4735 14.6765 15.2485 14.4515C15.0235 14.2265 14.7182 14.1 14.4 14.1ZM5.99998 12C5.99998 11.6818 6.1264 11.3765 6.35145 11.1515C6.57649 10.9265 6.88172 10.8 7.19998 10.8C7.51824 10.8 7.82346 10.9265 8.0485 11.1515C8.27355 11.3765 8.39998 11.6818 8.39998 12C8.39998 12.3183 8.27355 12.6235 8.0485 12.8486C7.82346 13.0736 7.51824 13.2 7.19998 13.2C6.88172 13.2 6.57649 13.0736 6.35145 12.8486C6.1264 12.6235 5.99998 12.3183 5.99998 12ZM7.19998 14.1C6.88172 14.1 6.57649 14.2265 6.35145 14.4515C6.1264 14.6765 5.99998 14.9818 5.99998 15.3C5.99998 15.6183 6.1264 15.9235 6.35145 16.1486C6.57649 16.3736 6.88172 16.5 7.19998 16.5C7.51824 16.5 7.82346 16.3736 8.0485 16.1486C8.27355 15.9235 8.39998 15.6183 8.39998 15.3C8.39998 14.9818 8.27355 14.6765 8.0485 14.4515C7.82346 14.2265 7.51824 14.1 7.19998 14.1ZM6.59998 2.40002C5.80433 2.40002 5.04126 2.71609 4.47866 3.2787C3.91605 3.84131 3.59998 4.60438 3.59998 5.40002V16.2C3.59998 16.9957 3.91605 17.7587 4.47866 18.3213C5.04126 18.884 5.80433 19.2 6.59998 19.2H15C15.7956 19.2 16.5587 18.884 17.1213 18.3213C17.6839 17.7587 18 16.9957 18 16.2V5.40002C18 4.60438 17.6839 3.84131 17.1213 3.2787C16.5587 2.71609 15.7956 2.40002 15 2.40002H6.59998ZM4.79998 5.40002C4.79998 4.92263 4.98962 4.4648 5.32718 4.12723C5.66475 3.78967 6.12259 3.60002 6.59998 3.60002H15C15.4774 3.60002 15.9352 3.78967 16.2728 4.12723C16.6103 4.4648 16.8 4.92263 16.8 5.40002V16.2C16.8 16.6774 16.6103 17.1353 16.2728 17.4728C15.9352 17.8104 15.4774 18 15 18H6.59998C6.12259 18 5.66475 17.8104 5.32718 17.4728C4.98962 17.1353 4.79998 16.6774 4.79998 16.2V5.40002ZM8.99998 21.6C8.53417 21.6004 8.07471 21.4921 7.65808 21.2838C7.24146 21.0755 6.87916 20.7729 6.59998 20.4H15C16.1139 20.4 17.1822 19.9575 17.9698 19.1699C18.7575 18.3822 19.2 17.3139 19.2 16.2V5.40002C19.9284 5.94722 20.4 6.81842 20.4 7.80002V16.2C20.4 17.6322 19.831 19.0057 18.8184 20.0184C17.8057 21.0311 16.4321 21.6 15 21.6H8.99998Z" />
                        </svg>
                      </div>
                      {this.props.isMenuOpen && (
                        <div className="menu-title">
                          {t('APP.SHARED.SIDEBAR.PH_E2608E', {
                            defaultValue: 'Simulateur rapide',
                          })}
                        </div>
                      )}
                    </div>
                  </Tooltip>
                )}
              </li>
              <li
                data-testid="product-catalog"
                className={
                  this.isPathActive('/products')
                    ? this.props.isDarkMode
                      ? 'nav-item active dark'
                      : 'nav-item active'
                    : this.props.isDarkMode
                    ? 'nav-item dark'
                    : 'nav-item'
                }
                style={{
                  backgroundColor:
                    this.props.licenceTypeAccess === 'read' ? '#E9EDF6' : '',
                  cursor:
                    this.props.licenceTypeAccess === 'read' ? 'not-allowed' : '',
                }}
              >
                {this.props.licenceTypeAccess !== 'read' && (
                  <Link
                    className={this.props.isDarkMode ? 'nav-link dark' : 'nav-link'}
                    to={'/products'}
                  >
                    {/* <img src={catalogPic} alt="" style={{ filter: ' brightness(0) invert(1)', }} className="non-active menu-icon" /> */}
                    <div
                      className={
                        this.isPathActive('/products')
                          ? 'svgWrapper active'
                          : 'svgWrapper'
                      }
                    >
                      {!this.props.isMenuOpen ? (
                        <Tooltip
                          title={t('APP.SHARED.SIDEBAR.PH_146A86', {
                            defaultValue: 'Catalogue produits',
                          })}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="current"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_116_959)">
                              <path d="M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13V17.13Z" />
                            </g>
                            <defs>
                              <clipPath id="clip0_116_959">
                                <rect width="24" height="24" />
                              </clipPath>
                            </defs>
                          </svg>
                        </Tooltip>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="current"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_116_959)">
                            <path d="M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13V17.13Z" />
                          </g>
                          <defs>
                            <clipPath id="clip0_116_959">
                              <rect width="24" height="24" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </div>
                    {this.props.isMenuOpen && (
                      <div className="menu-title">
                        {t('APP.SHARED.SIDEBAR.PH_684CAF', {
                          defaultValue: 'Catalogue produits',
                        })}
                      </div>
                    )}
                  </Link>
                )}

                {this.props.licenceTypeAccess === 'read' && (
                  <Tooltip
                    title="Fonctionnalité disponible avec une licence light ou pro seulement"
                    placement="right"
                  >
                    <div
                      className={
                        this.props.isDarkMode ? 'nav-link dark' : 'nav-link'
                      }
                    >
                      {/* <img src={catalogPic} alt="" style={{ filter: ' brightness(0) invert(1)', }} className="non-active menu-icon" /> */}
                      <div
                        className={
                          this.isPathActive('/produits')
                            ? 'svgWrapper active'
                            : 'svgWrapper'
                        }
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="current"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_116_959)">
                            <path d="M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13V17.13Z" />
                          </g>
                          <defs>
                            <clipPath id="clip0_116_959">
                              <rect width="24" height="24" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      {this.props.isMenuOpen && (
                        <div
                          style={{
                            cursor: 'not-allowed',
                          }}
                          className="menu-title"
                        >
                          {t('APP.SHARED.SIDEBAR.PH_3C6FB9', {
                            defaultValue: 'Catalogue produits',
                          })}
                        </div>
                      )}
                    </div>
                  </Tooltip>
                )}
              </li>
              <li
                className={
                  this.isPathActive('/help')
                    ? this.props.isDarkMode
                      ? 'nav-item active dark'
                      : 'nav-item active'
                    : this.props.isDarkMode
                    ? 'nav-item dark'
                    : `nav-item ${isEnglishLanguage ? 'disabled' : ''}`
                }
              >
                <Link className={`nav-link `} to={isEnglishLanguage ? '#' : '/help'}>
                  <div
                    className="notification__container"
                    data-testid="notificationButton"
                    style={{ position: 'relative' }}
                  >
                    {!this.props.isNewFeature2 && (
                      <div
                        className={
                          this.isPathActive('/help')
                            ? 'svgWrapper active'
                            : 'svgWrapper'
                        }
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="current"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M7.93,5.73A3,3,0,0,1,9.39,5.4,2.85,2.85,0,0,1,11.16,6,2.6,2.6,0,0,1,12.1,8.1a2.43,2.43,0,0,1-1.17,2l-.09.07c-.46.36-.64.56-.64,1a.81.81,0,0,1-.23.57.84.84,0,0,1-.58.24.82.82,0,0,1-.81-.81A2.7,2.7,0,0,1,9.84,8.85c.55-.44.63-.54.63-.75a1,1,0,0,0-.34-.82A1.17,1.17,0,0,0,9.39,7a1.41,1.41,0,0,0-.7.14,1.17,1.17,0,0,0-.48.52.78.78,0,0,1-.2.24.76.76,0,0,1-.28.15A.83.83,0,0,1,7.11,8a.79.79,0,0,1-.24-.21.69.69,0,0,1-.15-.28.8.8,0,0,1,0-.31.75.75,0,0,1,.09-.3A2.79,2.79,0,0,1,7.93,5.73Zm1.46,9.4a1.06,1.06,0,0,0,1.08-1.08A1.08,1.08,0,0,0,9.39,13a1.09,1.09,0,0,0-1.08,1.08,1.08,1.08,0,0,0,1.08,1.08Zm0-13A8.1,8.1,0,0,0,2.55,5.91,8.06,8.06,0,0,0,1.29,9.74a8.2,8.2,0,0,0,.75,4l-.79,3.07a1.46,1.46,0,0,0,0,.69,1.38,1.38,0,0,0,.34.6,1.54,1.54,0,0,0,.59.35,1.35,1.35,0,0,0,.69,0l3.17-.76a8.08,8.08,0,0,0,7-.15,8.27,8.27,0,0,0,2.77-2.28,8.13,8.13,0,0,0,1.47-6.84A8.1,8.1,0,0,0,12.89,3,8,8,0,0,0,9.39,2.15ZM2.9,10.27a6.5,6.5,0,1,1,3.6,5.81L6.24,16,6,16l-3,.72c.21-.84.5-2,.74-2.93l.08-.3-.14-.27A6.54,6.54,0,0,1,2.9,10.27ZM14.8,21.63a8.12,8.12,0,0,1-5.52-2.17h.11a8.78,8.78,0,0,0,2.25-.28,6.53,6.53,0,0,0,6.05.15L18,19.2l.29.06c1,.24,2.13.48,3,.66-.22-1-.45-1.91-.69-2.86l-.08-.3.14-.28a6.41,6.41,0,0,0,.72-3,6.53,6.53,0,0,0-.79-3.11,6.44,6.44,0,0,0-2.18-2.34,9.21,9.21,0,0,0-.86-2.22,8.11,8.11,0,0,1,4.81,4.51,8,8,0,0,1,.65,3.31,8.09,8.09,0,0,1-.77,3.28c.28,1.1.56,2.28.73,3a1.38,1.38,0,0,1,0,.67,1.34,1.34,0,0,1-.34.57,1.22,1.22,0,0,1-.57.35,1.27,1.27,0,0,1-.67,0c-.78-.16-2-.43-3.15-.69A8.19,8.19,0,0,1,14.8,21.63Z" />
                          S
                        </svg>
                      </div>
                    )}

                    {this.props.isNewFeature2 && (
                      <>
                        {/* <NewReleasesIcon style={{marginRight: '1.25rem', width: '19px', height: '19px' }}/> */}
                        <div
                          className={
                            this.isPathActive('/help')
                              ? 'svgWrapper active'
                              : 'svgWrapper'
                          }
                        >
                          {!this.props.isMenuOpen ? (
                            <Tooltip
                              title={t('APP.SHARED.SIDEBAR.PH_87E791', {
                                defaultValue: 'Aide / Nouveautés',
                              })}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="current"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M7.93,5.73A3,3,0,0,1,9.39,5.4,2.85,2.85,0,0,1,11.16,6,2.6,2.6,0,0,1,12.1,8.1a2.43,2.43,0,0,1-1.17,2l-.09.07c-.46.36-.64.56-.64,1a.81.81,0,0,1-.23.57.84.84,0,0,1-.58.24.82.82,0,0,1-.81-.81A2.7,2.7,0,0,1,9.84,8.85c.55-.44.63-.54.63-.75a1,1,0,0,0-.34-.82A1.17,1.17,0,0,0,9.39,7a1.41,1.41,0,0,0-.7.14,1.17,1.17,0,0,0-.48.52.78.78,0,0,1-.2.24.76.76,0,0,1-.28.15A.83.83,0,0,1,7.11,8a.79.79,0,0,1-.24-.21.69.69,0,0,1-.15-.28.8.8,0,0,1,0-.31.75.75,0,0,1,.09-.3A2.79,2.79,0,0,1,7.93,5.73Zm1.46,9.4a1.06,1.06,0,0,0,1.08-1.08A1.08,1.08,0,0,0,9.39,13a1.09,1.09,0,0,0-1.08,1.08,1.08,1.08,0,0,0,1.08,1.08Zm0-13A8.1,8.1,0,0,0,2.55,5.91,8.06,8.06,0,0,0,1.29,9.74a8.2,8.2,0,0,0,.75,4l-.79,3.07a1.46,1.46,0,0,0,0,.69,1.38,1.38,0,0,0,.34.6,1.54,1.54,0,0,0,.59.35,1.35,1.35,0,0,0,.69,0l3.17-.76a8.08,8.08,0,0,0,7-.15,8.27,8.27,0,0,0,2.77-2.28,8.13,8.13,0,0,0,1.47-6.84A8.1,8.1,0,0,0,12.89,3,8,8,0,0,0,9.39,2.15ZM2.9,10.27a6.5,6.5,0,1,1,3.6,5.81L6.24,16,6,16l-3,.72c.21-.84.5-2,.74-2.93l.08-.3-.14-.27A6.54,6.54,0,0,1,2.9,10.27ZM14.8,21.63a8.12,8.12,0,0,1-5.52-2.17h.11a8.78,8.78,0,0,0,2.25-.28,6.53,6.53,0,0,0,6.05.15L18,19.2l.29.06c1,.24,2.13.48,3,.66-.22-1-.45-1.91-.69-2.86l-.08-.3.14-.28a6.41,6.41,0,0,0,.72-3,6.53,6.53,0,0,0-.79-3.11,6.44,6.44,0,0,0-2.18-2.34,9.21,9.21,0,0,0-.86-2.22,8.11,8.11,0,0,1,4.81,4.51,8,8,0,0,1,.65,3.31,8.09,8.09,0,0,1-.77,3.28c.28,1.1.56,2.28.73,3a1.38,1.38,0,0,1,0,.67,1.34,1.34,0,0,1-.34.57,1.22,1.22,0,0,1-.57.35,1.27,1.27,0,0,1-.67,0c-.78-.16-2-.43-3.15-.69A8.19,8.19,0,0,1,14.8,21.63Z" />
                              </svg>
                            </Tooltip>
                          ) : (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="current"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7.93,5.73A3,3,0,0,1,9.39,5.4,2.85,2.85,0,0,1,11.16,6,2.6,2.6,0,0,1,12.1,8.1a2.43,2.43,0,0,1-1.17,2l-.09.07c-.46.36-.64.56-.64,1a.81.81,0,0,1-.23.57.84.84,0,0,1-.58.24.82.82,0,0,1-.81-.81A2.7,2.7,0,0,1,9.84,8.85c.55-.44.63-.54.63-.75a1,1,0,0,0-.34-.82A1.17,1.17,0,0,0,9.39,7a1.41,1.41,0,0,0-.7.14,1.17,1.17,0,0,0-.48.52.78.78,0,0,1-.2.24.76.76,0,0,1-.28.15A.83.83,0,0,1,7.11,8a.79.79,0,0,1-.24-.21.69.69,0,0,1-.15-.28.8.8,0,0,1,0-.31.75.75,0,0,1,.09-.3A2.79,2.79,0,0,1,7.93,5.73Zm1.46,9.4a1.06,1.06,0,0,0,1.08-1.08A1.08,1.08,0,0,0,9.39,13a1.09,1.09,0,0,0-1.08,1.08,1.08,1.08,0,0,0,1.08,1.08Zm0-13A8.1,8.1,0,0,0,2.55,5.91,8.06,8.06,0,0,0,1.29,9.74a8.2,8.2,0,0,0,.75,4l-.79,3.07a1.46,1.46,0,0,0,0,.69,1.38,1.38,0,0,0,.34.6,1.54,1.54,0,0,0,.59.35,1.35,1.35,0,0,0,.69,0l3.17-.76a8.08,8.08,0,0,0,7-.15,8.27,8.27,0,0,0,2.77-2.28,8.13,8.13,0,0,0,1.47-6.84A8.1,8.1,0,0,0,12.89,3,8,8,0,0,0,9.39,2.15ZM2.9,10.27a6.5,6.5,0,1,1,3.6,5.81L6.24,16,6,16l-3,.72c.21-.84.5-2,.74-2.93l.08-.3-.14-.27A6.54,6.54,0,0,1,2.9,10.27ZM14.8,21.63a8.12,8.12,0,0,1-5.52-2.17h.11a8.78,8.78,0,0,0,2.25-.28,6.53,6.53,0,0,0,6.05.15L18,19.2l.29.06c1,.24,2.13.48,3,.66-.22-1-.45-1.91-.69-2.86l-.08-.3.14-.28a6.41,6.41,0,0,0,.72-3,6.53,6.53,0,0,0-.79-3.11,6.44,6.44,0,0,0-2.18-2.34,9.21,9.21,0,0,0-.86-2.22,8.11,8.11,0,0,1,4.81,4.51,8,8,0,0,1,.65,3.31,8.09,8.09,0,0,1-.77,3.28c.28,1.1.56,2.28.73,3a1.38,1.38,0,0,1,0,.67,1.34,1.34,0,0,1-.34.57,1.22,1.22,0,0,1-.57.35,1.27,1.27,0,0,1-.67,0c-.78-.16-2-.43-3.15-.69A8.19,8.19,0,0,1,14.8,21.63Z" />
                            </svg>
                          )}
                        </div>
                        <div className="bubble-1"></div>
                        <div className="bubble-2"></div>
                      </>
                    )}

                    {this.props.isMenuOpen && !this.props.isNewFeature2 && (
                      <div
                        className="menu-title"
                        style={{
                          color: this.isPathActive('/help')
                            ? '#fafafa'
                            : this.props.isDarkMode
                            ? '#fafafa'
                            : '#A3AED0',
                        }}
                      >
                        {t('APP.SHARED.SIDEBAR.PH_EC958F', {
                          defaultValue: 'Aide',
                        })}
                      </div>
                    )}

                    {this.props.isMenuOpen && this.props.isNewFeature2 && (
                      <div
                        className="menu-title"
                        style={{
                          color: this.isPathActive('/help')
                            ? '#fafafa'
                            : this.props.isDarkMode
                            ? '#fafafa'
                            : '#A3AED0',
                        }}
                      >
                        {t('APP.SHARED.SIDEBAR.PH_9239D3', {
                          defaultValue: 'Aide nouveautés',
                        })}
                      </div>
                    )}
                  </div>
                </Link>
              </li>
              {/* DarkMode toggle */}
              {/* {
                        this.props.isMenuOpen && (
                          <Switch
                            checkedChildren="Dark" 
                            unCheckedChildren="Light" 
                            checked={this.props.isDarkMode ? true : false} 
                            onChange={() => { this.props.updateCheckValue('isDarkMode',
                              !this.props.isDarkMode); }} 
                          />
                        )
                       } */}

              {this.props.isMenuOpen && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    margin: '1em',
                  }}
                >
                  <Tooltip
                    title={t('APP.SHARED.SIDEBAR.BI_BUTTON', {
                      defaultValue: 'Redirection vers la plateforme de BI',
                    })}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://eu-west-1.quicksight.aws.amazon.com/sn/start/dashboards"
                    >
                      <Button
                        className="save-button filter-white-img"
                        centeredIcon={<img style={{ width: '20px' }} src={biPng} />}
                      />
                    </a>
                  </Tooltip>
                  <Tooltip
                    title={t('APP.SHARED.SIDEBAR.MANUFACTURERS_BUTTON', {
                      defaultValue: 'Redirection vers la plateforme Fabricant',
                    })}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://manufacturers.nooco.com/"
                    >
                      <Button
                        className="save-button filter-white-img"
                        centeredIcon={
                          <img style={{ width: '20px' }} src={manufPng} />
                        }
                      />
                    </a>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          <a>
            <li
              data-testid="logout-button"
              className={
                this.isPathActive('/falls')
                  ? this.props.isDarkMode
                    ? 'nav-item active dark'
                    : 'nav-item active'
                  : this.props.isDarkMode
                  ? 'nav-item menu-div dark'
                  : 'nav-item menu-div'
              }
              onClick={async () => {
                await this.logout();
              }}
            >
              <div className="nav-link">
                {/* <i className="mdi mdi-logout menu-icon" /> */}
                <div
                  className={
                    this.isPathActive('/falls') ? 'svgWrapper active' : 'svgWrapper'
                  }
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="current"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_431_4415)">
                      <path d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z" />
                    </g>
                    <defs>
                      <clipPath id="clip0_431_4415">
                        <rect width="24" height="24" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                {this.props.isMenuOpen && (
                  <div className="menu-title">
                    {t('APP.SHARED.SIDEBAR.PH_60966D', {
                      defaultValue: 'Déconnexion',
                    })}
                  </div>
                )}
              </div>
            </li>
          </a>
        </ul>
        <div
          className={
            this.props.isMenuOpen
              ? this.props.isDarkMode
                ? 'icon-expand dark'
                : 'icon-expand'
              : this.props.isDarkMode
              ? 'icon-small dark'
              : 'icon-small'
          }
        >
          <ChevronLeftIcon
            style={{ color: '#ffffff', cursor: 'pointer', fontSize: '24px' }}
            onClick={this.props.toggleMenu}
          />
        </div>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.props.fetchFeatures();
    this.props.featureUpdate(
      'localFeature',
      JSON.parse(localStorage.getItem('featuresConsulted')) || []
    );

    this.props.fetchReleases();
    this.props.releaseUpdate('loadingRelease', true);
  }
}

export default withTranslation()(withRouter(Sidebar));
